import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { StorageService } from 'src/app/services/storage.service';

@Pipe({
  name: 'decimalPipeComercialPrecio'
})
export class DecimalPipeComercialPrecioPipe implements PipeTransform {

  public factores: any = {};
  public decimalPrecio: string = '';

  constructor(private decimalPipe: DecimalPipe) {
    this.factores = JSON.parse(StorageService.getSession()).factores;
    if (this.factores != null && this.factores.decimalesComercialPrecio != null) {
      this.decimalPrecio = this.factores.decimalesComercialPrecio;
    } else {
      this.decimalPrecio = '2';
    }
  }

  transform(value: string, ...args: unknown[]): unknown {
    const format = args[0] ? `0.${this.decimalPrecio}-${this.decimalPrecio}` : `0.${this.decimalPrecio}-${this.decimalPrecio}`;
    return this.decimalPipe.transform(value, format);
  }
}
